<template>
    <div class="users-admin-view">
        <AdminTable class="ma-4"
                    :items="items"
                    :get-headers="getHeaders" />
    </div>
</template>

<script>
    import AdminTable from "@/components/admin/AdminTable.vue";

    export default {
        components: {
            AdminTable
        },

        data() {
            return {
            };
        },

        created() {
            this.$store.dispatch("admin/loadUsers");
        },

        computed: {
            items() {
                return this.$store.state.admin.users
                    .map(e => ({
                        id: e.id,
                        userName: e.userName,
                        email: e.email,
                        emailConfirmed: this.getBoolString(e.emailConfirmed),
                        roles: e.roles.join(", "),
                        daysResultsCount: e.daysResultsCount,
                        daysTasksCount: e.daysTasksCount,
                        habitsCount: e.habitsCount,
                        groupsCount: e.groupsCount,
                        createdGroupsCount: e.createdGroupsCount,
                        sentInvitationsCount: e.sentInvitationsCount,
                        receivedInvitationsCount: e.receivedInvitationsCount,
                        isGreyRow: !e.emailConfirmed,
                        rawItem: e
                    }));
            }
        },

        watch: {

        },

        methods: {
            getBoolString(bool) {
                return bool === true
                    ? "Да"
                    : "Нет";
            },

            getHeaders() {
                return [
                    {
                        title: "Логин",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "userName"
                    },
                    {
                        title: "email",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "email"
                    },
                    {
                        title: "email подтверждён",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "emailConfirmed"
                    },
                    {
                        title: "Роли",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "roles"
                    },
                    {
                        title: "Количество результатов",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "daysResultsCount"
                    },
                    {
                        title: "Количество задач",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "daysTasksCount"
                    },
                    {
                        title: "Количество привычек",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "habitsCount"
                    },
                    {
                        title: "Количество групп",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "groupsCount"
                    },
                    {
                        title: "Количество созданных групп",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "createdGroupsCount"
                    },
                    {
                        title: "Количество отправленных приглашений",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "sentInvitationsCount"
                    },
                    {
                        title: "Количество полученных приглашений",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "receivedInvitationsCount"
                    }
                ];
            }
        }
    };
</script>

<style lang="scss">
    .users-admin-view {
    }
</style>